import React, { useState } from 'react';
import { BeforeAfterSlider } from './components/BeforeAfterSlider/BeforeAfterSlider';
import styles from './App.module.scss';
import { WhyProcess } from './components/WhyProcess/WhyProcess';
import { CallToAction } from './components/CallToAction/CallToAction';
import { Pricing } from './components/Pricing/Pricing';
import { data } from './components/BeforeAfterSlider/data';
import { ProcessSection } from './components/ProcessSection/ProcessSection';
import { Footer } from './components/Footer/Fooret';
import Header from './components/Header/Header';

function App() {


  return (
    <div className={styles.pageWrapper}>
      <div className={`${styles.container} ${styles.welcomeContainer}`}>
        <img className={`${styles.shape} ${styles.shape1}`} src='img/shapes/1.png' />
        <div className={styles.containerInner}>

          {/* Хедер */}
          <Header />

          {/* Главный блок (Hero) */}
          <main className={`${styles.hero} ${styles.mobileHero}`}>
            <div className={styles.heroContent}>
              <h1 className={styles.title}>
                Создание <span className={styles.textGradientTop}>продающей</span> <br />
                <span className={styles.textGradientBottom}>фотографии</span> жилых <br />
                помещений
              </h1>
            </div>
          </main>
          <main className={styles.hero}>
            <div className={styles.heroContent}>
              <h1 className={styles.title}>
                Создание <span className={styles.textGradientTop}>продающей</span> <br />
                <span className={styles.textGradientBottom}>фотографии</span> жилых <br />
                помещений
              </h1>

              <ul className={styles.features}>
                <li>– Увеличить количество броней для посуточной сдачи или отелей</li>
                <li>– Поднять стоимость квартиры на продажу</li>
                <li>– Показать на фотографии настоящую атмосферу квартиры</li>
              </ul>

              <div className={styles.heroActions}>
                <button className={styles.btnSecondary}>Стоимость</button>
                <button className={styles.btnPrimary}>Заказать обработку</button>
              </div>
            </div>

            <BeforeAfterSlider />
          </main>

          {/* Шаги работы */}
          <div className={styles.processSteps}>
            <div className={styles.step}>
              <span className={styles.stepNum}>#01</span>
              <span className={styles.stepText}>Отправка фотографий</span>
            </div>
            <div className={styles.step}>
              <span className={styles.stepNum}>#02</span>
              <span className={styles.stepText}>Редактирование</span>
            </div>
            <div className={styles.step}>
              <span className={styles.stepNum}>#03</span>
              <span className={styles.stepText}>Внесение правок</span>
            </div>
            <div className={styles.step}>
              <span className={styles.stepNum}>#04</span>
              <span className={styles.stepText}>Получение результата</span>
            </div>
            <div className={styles.step}>
              <span className={styles.stepNumText}>
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="13" cy="13" r="8" fill="#22C55E" />
                  <circle cx="13" cy="13" r="12" stroke="#22C55E" strokeWidth="1" />
                  <path d="M9 13L11.5 15.5L17 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg> #05
              </span>
              <span className={styles.stepText}>Оплата после результата</span>
            </div>
          </div>
        </div>
      </div >

      <div className={styles.container} style={{
        background: "#f3f4f6",
        paddingTop: "100px",
        paddingBottom: "100px",
      }}>
        <div className={styles.containerInner}>
          <WhyProcess />
        </div>
      </div>
      <div className={styles.container} style={{
        background: "none",
        padding: "0",
        maxWidth: "2120px",
      }}>
        <CallToAction />
      </div>
      <div className={styles.container} style={{
        background: "radial-gradient(circle at 45% 100%, rgba(120, 38, 28, 0.8) 0%, transparent 50%),radial-gradient(circle at 100% 100%, rgba(11, 102, 116, 0.8) 0%, transparent 50%),radial-gradient(circle at 0% 0%, rgba(21, 60, 64, 0.6) 0%, transparent 50%),#1e2124;",
        paddingTop: "60px",
      }}>
        <img className={`${styles.shape} ${styles.shape2}`} src='img/shapes/2.png' />
        <div className={styles.containerInner}>

          <Pricing />
        </div>
      </div>
      <div className={styles.container} style={{
        background: "#f3f4f6",
        paddingTop: "100px",
        paddingBottom: "100px",
      }}>
        <div className={styles.containerInner}>
          <ProcessSection />
        </div>
      </div>
      <div className={styles.container} style={{
        background: "none",
        padding: "0",
        maxWidth: "2120px",
      }}>
        <CallToAction />
      </div>
      <div className={styles.container} style={{
        background: "radial-gradient(circle at 45% 100%, rgba(120, 38, 28, 0.8) 0%, transparent 50%),radial-gradient(circle at 100% 100%, rgba(11, 102, 116, 0.8) 0%, transparent 50%),radial-gradient(circle at 0% 0%, rgba(21, 60, 64, 0.6) 0%, transparent 50%),#1e2124;",
        paddingTop: "60px",
      }}>
        <div className={styles.containerInner}>
          <Footer />
        </div>
      </div>
    </div >
  );
}

export default App;